import Vue from 'vue'
import App from './App.vue'
import ErroInicializacao from './ErroInicializacao'
import {buildMenu} from '@azinformatica/loki'
import {actionTypes, mutationTypes} from './commons/constants'
import packageJson from '../package'
import router from './router'
import store from './commons/store'
import menuUtils from './commons/utils/MenuUtils'
import keycloak from './listeners/KeycloakListener'

class AppBuilder {

    async build() {
        await this._resolverDependencias()
            .then(() => {
                this._criarInstanciaVue()
            })
            .catch((erro) => {
                this._criarErroInicializacao(erro)
            })
    }

    async _resolverDependencias() {
        await this._buscarProduto()
        await keycloak.execute()
        await this._buscarParametrosSistema()
        await this._buscarUsuarioLogado()
        await this._buscarUsuarioDominioPerfis()
        await this._selecionarDominioPerfil()
        await this._buscarUrlCompraDireta()
        this._atualizarAvatarActions()
        await this._buscarSetup()
        await this._verificarNovaVersao()
    }

    async _verificarNovaVersao() {
        const notificarMajor = true
        const notificarMinor = true
        const versaoAtual = store.state.loki.product.version
        if (!localStorage.getItem('ultimaVersaoNovidade')) {
            localStorage.setItem('ultimaVersaoNovidade', '0.0.0')
        }
        const ultimaNovidadeVista = localStorage.getItem('ultimaVersaoNovidade')
        const majorAtual = parseInt(versaoAtual.split('.')[0])
        const ultimaMajor = parseInt(ultimaNovidadeVista.split('.')[0])
        const minorAtual = parseInt(versaoAtual.split('.')[1])
        const ultimaMinor = parseInt(ultimaNovidadeVista.split('.')[1])

        if (notificarMinor) {
            if (majorAtual >= ultimaMajor && minorAtual > ultimaMinor) {
                store.state.novidadeDisponivel = true
                return
            }
        }
        if (notificarMajor && majorAtual > ultimaMajor) {
            store.state.novidadeDisponivel = true
            return
        }
        store.state.novidadeDisponivel = false
    }

    async _buscarParametrosSistema() {
        await store.dispatch(actionTypes.BUSCAR_PARAMETROS)
    }

    async _buscarOrgaos() {
        await store.dispatch(actionTypes.BUSCAR_ORGAOS)
    }

    async _buscarProduto() {
        await store.dispatch(actionTypes.BUSCAR_PRODUTO_POR_NOME, packageJson)
    }

    async _buscarSetup() {
        await store.dispatch(actionTypes.BUSCAR_SETUP)
    }

    async _buscarUsuarioLogado() {
        await store.dispatch(actionTypes.BUSCAR_USUARIO_LOGADO)
    }


    async _buscarUsuarioDominioPerfis() {
        const usuarioId = store.state.loki.user.id
        let perfil
        if (this._ehPerfilFornecedor()) {
            perfil = 'Fornecedor'
        } else {
            perfil = this._selecionarPerfil()
        }
        await store.dispatch(actionTypes.BUSCAR_USUARIO_DOMINIO_PERFIL, {usuarioId, perfil})
    }

    _selecionarPerfil() {
        const authorities = store.state.loki.user.authorities
        const podeEditar = authorities.some(auth =>
            auth.name === "Credenciamento.Editar" && auth.hasAccess
        );

        if (podeEditar) {
            store.state.perfilCredenciamentoEdicao.value = true;
            return "CredenciamentoEditar";
        }

        const podeVisualizar = authorities.some(auth =>
            auth.name === "Credenciamento.Visualizar" && auth.hasAccess
        );

        if (podeVisualizar) {
            store.state.perfilCredenciamentoEdicao.value = false;
            return "CredenciamentoVisualizar";
        }

        return "OrgaoPublico";
    }


    async _selecionarDominioPerfil() {
        const perfis = store.state.perfis

        if (store.state.loki.user.domainId) {
            if (this._ehPerfilFornecedor()) {
                await this._validarPermissoesLicitante().catch(() => {})
            }
            return
        }

        if (perfis.length === 1) {
            const dominioDTO = {
                dominioClienteId: perfis[0].chaveCliente,
                dominioTipo: perfis[0].tipoCliente
            }
            await store.dispatch(actionTypes.ATUALIZAR_SESSAO_DOMINIO, dominioDTO)
            await this._validarPermissoesLicitante()
            await this._buscarUsuarioLogado()
        } else if (perfis.length > 1) {
            let redirectUrl = window.location.href
            if (redirectUrl) {
                router.push({
                    name: 'selecionarDominio',
                    query: {redirectUrl}
                })
            } else {
                router.push({name: 'selecionarDominio'})
            }
        } else if (this._ehPerfilFornecedor()) {
            const dominioDTO = {
                dominioClienteId: store.state.loki.user.domainId,
                dominioTipo: store.state.loki.user.domainType
            }
            await store.dispatch(actionTypes.ATUALIZAR_SESSAO_DOMINIO, dominioDTO)
            await this._validarPermissoesLicitante()
            await this._buscarUsuarioLogado()
        }
    }

    async _validarPermissoesLicitante() {

        const authorities = store.state.loki.user.authorities || []
        const perfis = store.state.perfis || []

        const temPermissaoVisualizar = authorities.some(function (p) {
            return p.name === 'Licitacao.Visualizar'
        })
        const temPermissaoAtualizar = authorities.some(function (p) {
            return p.name === 'Proposta.Atualizar'
        })
        const temPermissaoCredenciamentoFornecedor = authorities.some(function (p) {
            return p.name === 'Credenciamento.Fornecedor'
        })
        const temPerfilFornecedor = perfis.some(function (p) {
            return p.tipoCliente === 'FORNECEDOR'
        })

        const temPermissoesBasicas =
            ((temPermissaoVisualizar && temPermissaoAtualizar) || temPermissaoCredenciamentoFornecedor) &&
            temPerfilFornecedor

        if (temPermissoesBasicas) {
            return
        }
        if (!temPermissoesBasicas) {
            console.error('Erro: usuário fornecedor sem permissões básicas para acesso!')
            console.log('temPermissaoVisualizar: ', temPermissaoVisualizar)
            console.log('temPermissaoAtualizar: ', temPermissaoAtualizar)
            console.log('temPerfilFornecedor: ', temPerfilFornecedor)
            await store.dispatch(actionTypes.MANUTENCAO.ATUALIZAR_PERMISSOES_FORNECEDOR)
            await this._buscarUsuarioLogado()
        }
    }

    async _buscarUrlCompraDireta() {
        await store.dispatch(actionTypes.BUSCAR_URL_COMPRA_DIRETA)
    }

    _atualizarAvatarActions() {
        store.commit(mutationTypes.SET_MENU_AVATAR)
    }

    _ehPerfilFornecedor() {
        return store.state.loki.user.type === 'EXTERNO'
    }

    _criarInstanciaVue() {
        new Vue({
            router,
            store,
            render: h => h(App),
            created() {
                let menuActions = buildMenu(this.$store, this.$router)
                menuUtils.toggleDefaultExpanded(menuActions, 'Sobre')
                if (!this.$store.state.loki.user.domainId) {
                    menuActions = menuUtils.removeMenu(menuActions, 'Minhas Licitações')
                }
                const ehFornecedor = this.$store.state.loki.user.type === 'EXTERNO'
                if(!this.$store.state.parametros.propriedadesLicitacao.apresentarMenuConsultas || ehFornecedor){
                    menuActions = menuUtils.removeMenu(menuActions, 'Consultas')
                }
                menuActions = menuUtils.removeMenu(menuActions, 'Sobre')
                this.$store.commit('SET_MENU_ACTIONS', menuActions)
            },
            watch: {
                '$store.state.loki.user.authorities': {
                    deep: true,
                    immediate: true,
                    handler() {
                        let menuActions = buildMenu(this.$store, this.$router)
                        menuUtils.toggleDefaultExpanded(menuActions, 'Sobre')
                        if (!this.$store.state.loki.user.domainId) {
                            menuActions = menuUtils.removeMenu(menuActions, 'Minhas Licitações')
                        }
                        const ehFornecedor = this.$store.state.loki.user.type === 'EXTERNO'
                        if(!this.$store.state.parametros.propriedadesLicitacao.apresentarMenuConsultas || ehFornecedor){
                            menuActions = menuUtils.removeMenu(menuActions, 'Consultas')
                        }
                        menuActions = menuUtils.removeMenu(menuActions, 'Sobre')
                        this.$store.commit('SET_MENU_ACTIONS', menuActions)
                    }
                }
            }
        }).$mount('#app')
    }

    _criarErroInicializacao({response}) {
        let mensagem = ''
        if (response && response.data && response.data.message) {
            mensagem = response.data.message
        }
        new Vue({
            router,
            store,
            render: h => h(ErroInicializacao, {
                props: {
                    mensagemErro: mensagem
                }
            }),
        }).$mount('#app')
    }
}

export default new AppBuilder()
